export function getExtensionFromSignedUrl(path: string): string {
  return path.split('?').shift()?.split('/').pop()?.split('.').pop() as string;
}

export function downloadFile(data: Blob, fileName: string): void {
  const link = document.createElement('a');
  // create a blobURI pointing to our Blob
  link.href = URL.createObjectURL(data);
  link.target = '_blank';
  link.download = fileName;
  // some browser needs the anchor to be in the doc
  document.body.append(link);
  link.click();

  // in case the Blob uses a lot of memory
  setTimeout(() => {
    document.body.removeChild(link);
    URL.revokeObjectURL(link.href);
  }, 1000);
}

export function msToHoursMinutes(milliseconds: number): string {
  if (milliseconds < 0) {
    throw new Error('Input milliseconds must be non-negative.');
  }

  const hours = Math.floor(milliseconds / (1000 * 60 * 60));
  const remainingMilliseconds = milliseconds % (1000 * 60 * 60);
  const minutes = Math.floor(remainingMilliseconds / (1000 * 60));

  if (hours === 0) {
    return `${minutes} min`;
  } else {
    return `${hours} hour${hours > 1 ? 's' : ''} ${minutes} min`;
  }
}

export function toHHMMSS(input: string | number): string {
  let totalSeconds: number;

  if (typeof input === 'number') {
    totalSeconds = Math.max(0, input);
  } else {
    const parts = input.split(':').map(Number).reverse();
    totalSeconds = parts[0] * 1 + (parts[1] || 0) * 60 + (parts[2] || 0) * 3600;
  }
  const hours: number = Math.floor(totalSeconds / 3600);
  const minutes: number = Math.floor((totalSeconds % 3600) / 60);
  const seconds: number = Math.floor(totalSeconds % 60);
  return `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
}

function pad(num: number): string {
  return num.toString().padStart(2, '0');
}

/**
 * Parses a time string (HH:MM:SS, MM:SS, or M:SS) to seconds.
 * Returns null if the input is invalid.
 */
export function parseTimeToSeconds(input: string): number | null {
  if (!input || typeof input !== 'string') return null;
  const trimmed = input.trim();
  if (!trimmed) return null;
  const parts = trimmed.split(':').map((p) => parseInt(p, 10));
  if (parts.some((n) => isNaN(n) || n < 0)) return null;
  if (parts.length === 1) {
    return Math.max(0, parts[0]);
  }
  if (parts.length === 2) {
    return Math.max(0, parts[0] * 60 + parts[1]);
  }
  if (parts.length >= 3) {
    return Math.max(0, parts[0] * 3600 + parts[1] * 60 + parts[2]);
  }
  return null;
}

export function formatSeconds(seconds: number): string {
  const date = new Date(seconds * 1000);
  return date.toISOString().substr(11, 8);
}
